import React from 'react';
import { Divider, Paper, Typography } from '@mui/material';
import FormPaper from './FormPaper';
import { EventReport } from '../core/api/clients';
import EventReportWrapper from './EventReportWrapper';
import useGetReportColor from '../core/api/hooks/common/useGetReportColor';
import { getColor } from '../core/colors';

interface IReportLinkContainer {
  color: string | null | undefined;
  reports: EventReport[];
  onPrimaryClick: (eventReport: EventReport) => void;
  primaryText: string;
  headerText: string;
  subText: string;
}
function ReportLinkContainer({ color, reports, onPrimaryClick, primaryText, headerText, subText }: IReportLinkContainer) {
  const { getFormColor } = useGetReportColor();
  return (
    <FormPaper color={color}>
      <Typography variant="h5" sx={{ mb: 1 }}>{headerText}</Typography>
      <Typography
        variant="body1"
        sx={{
          mb: 0,
          color: getColor(color)[500],
          fontWeight: 300,
        }}
      >
        {subText}
      </Typography>
      <Paper sx={{ p: 3 }}>
        {reports.length === 0 ? (
          <Typography variant="body1">No Reports to display</Typography>
        ) : (
          reports.map((report, index) => (
            <React.Fragment key={report.id}>
              <EventReportWrapper
                eventReport={report}
                color={getFormColor(report.reportType)}
                onPrimaryClick={onPrimaryClick}
                primaryText={primaryText}
              />
              {index < reports.length - 1 && (
                <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
              )}
            </React.Fragment>
          ))
        )}
      </Paper>
    </FormPaper>
  );
}

export default ReportLinkContainer;
